import React from 'react';
import Toolbar from './../_toolbar';

class TextHTML extends React.Component {

  render(){

    const { component } = this.props;
    const { element }   = component;

    return(
       <div>
         <Toolbar component={ component }/>
         <div dangerouslySetInnerHTML={{ __html: element.text }}/>
       </div>
    )

  }

}

export default TextHTML;
